export { YotpoBrandReviews } from '@/components/common/YotpoBrandReviews/YotpoBrandReviews';
